import script from "./TrainersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainersPage.vue?vue&type=script&setup=true&lang=js"

import "./TrainersPage.vue?vue&type=style&index=0&id=fb0a9fd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb0a9fd8"]])

export default __exports__